type LoadingScreenProps = {
  text?: string;
};

export default function LoadingScreen({
  text = "Loading...",
}: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6">
      <div
        className="h-14 w-14 animate-spin rounded-full bg-[conic-gradient(from_90deg,transparent_0deg,#2563eb_300deg)] [mask:radial-gradient(farthest-side,transparent_calc(100%-5px),#000_calc(100%-5px))] [-webkit-mask:radial-gradient(farthest-side,transparent_calc(100%-5px),#000_calc(100%-5px))]"
        style={{ animationDuration: "0.9s" }}
      />
      <p className="text-slate-400 text-sm font-medium tracking-widest uppercase animate-pulse">
        {text}
      </p>
    </div>
  );
}
